<template>
	<div>
		<div class="d-grid d-sm-flex justify-content-sm-between gap-2 mb-2">
			<router-link :to="{path: '/admin/disciplines'}" class="btn btn-outline-secondary">{{$t('btn.goto-disciplines')}}</router-link>
			<form role="form" style="min-width: 50%;" @submit.prevent="page = 1; loadData();">
				<div class="input-group">
					<input type="text" v-model="search" class="form-control" :placeholder="$t('placeholder.search')" />
					<button type="submit" class="btn btn-outline-secondary" :disabled="loading" :content="$t('tooltip.btn.search')" v-tippy="{placement: 'top'}">
						<font-awesome-icon :icon="['fas', loading ? 'spinner' : 'magnifying-glass']" :spin="loading" />
					</button>
				</div>
			</form>
			<div class="d-grid d-sm-flex gap-2" v-if="discipline">
				<a :href="'/api/pdf/questions/'+$route.params.discipline_id+'?lang='+appModel.getLang()" target="_blank" class="btn btn-outline-secondary">{{$t('btn.download-questions')}}</a>
				<button type="button" class="btn btn-outline-primary" @click="onShowAddModal()">{{$t('btn.add-question')}}</button>
			</div>
		</div>
		<div class="card mb-2" v-if="discipline">
			<div class="card-body">
				<div class="row">
					<div class="col-md-2 text-md-end"><b>{{$t('text.discipline')}}:</b></div>
					<div class="col-md-8">{{discipline.name}}</div>
					<div class="col-md-1 text-md-end"><b>{{$t('text.lang')}}:</b></div>
					<div class="col-md-1">{{discipline.lang.toUpperCase()}}</div>
				</div>
			</div>
		</div>
		<div class="table-responsive">
			<table class="table table-hover align-middle">
				<thead>
					<tr>
						<th scope="col">{{$t('text.question')}}</th>
						<th scope="col" width="50"></th>
						<th scope="col" class="text-end" width="100">
							<font-awesome-icon :icon="['fas', 'spinner']" spin v-if="loading" />
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="question in questions" :key="question.id">
						<td>{{question.text}}</td>
						<td>{{question.answers.length}}</td>
						<td>
							<div class="btn-toolbar justify-content-end gap-2">
								<div class="btn-group">
									<button type="button" class="btn btn-outline-primary" @click="onShowEditModal(question.id)" :content="$t('tooltip.btn.change')" v-tippy="{placement: 'top'}">
										<font-awesome-icon :icon="['fas', 'pencil']" />
									</button>
									<button type="button" class="btn btn-outline-danger" @click="onShowDeleteModal(question.id)" :content="$t('tooltip.btn.delete')" v-tippy="{placement: 'top'}">
										<font-awesome-icon :icon="['fas', 'trash-can']" />
									</button>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="text-center mt-2">
			<div class="mb-1">{{$t('text.total-questions')}}: {{questions_count}}</div>
			<nav aria-label="Page navigation">
				<ul class="pagination justify-content-center mb-0">
					<li class="page-item" :class="{'disabled': page == 1}">
						<a class="page-link" href="javascript://" @click="gotoPage(page - 1)" aria-label="Previous">
							<font-awesome-icon :icon="['fas', 'chevron-left']" />
						</a>
					</li>
					<li class="page-item" :class="{'active': page == 1}">
						<a class="page-link" href="javascript://" @click="gotoPage(1)">1</a>
					</li>
					<li class="page-item disabled" v-if="page - paginationAlpha > 2">
						<span class="page-link">...</span>
					</li>
					<li class="page-item" :class="{'active': page == i}" v-for="i in range(paginationA1, paginationA2)" :key="i" v-show="paginationA2 >= paginationA1">
						<a class="page-link" href="javascript://" @click="gotoPage(i)">{{i}}</a>
					</li>
					<li class="page-item disabled" v-if="page + paginationAlpha < getPagesCount() - 1">
						<span class="page-link">...</span>
					</li>
					<li class="page-item" :class="{'active': page == getPagesCount()}" v-if="getPagesCount() > 1">
						<a class="page-link" href="javascript://" @click="gotoPage(getPagesCount())">{{getPagesCount()}}</a>
					</li>
					<li class="page-item" :class="{'disabled': page == getPagesCount() || getPagesCount() == 0}">
						<a class="page-link" href="javascript://" @click="gotoPage(page + 1)" aria-label="Next">
							<font-awesome-icon :icon="['fas', 'chevron-right']" />
						</a>
					</li>
				</ul>
			</nav>
		</div>
	</div>
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import QuestionAddModal from '@/components/modals/questions/QuestionAddModal';
import QuestionEditModal from '@/components/modals/questions/QuestionEditModal';
import QuestionDeleteModal from '@/components/modals/questions/QuestionDeleteModal';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'База вопросов дисциплины | KMIB EDU Admin'});
	},
	data: () => ({
		discipline: null,
		
		questions: [],
		questions_count: 0,
		
		search: '',
		page: 1,
		limit: 25,
		loading: true,
		error: '',
		
		paginationAlpha: 3,
	}),
	computed: {
		paginationA1(){
			return Math.max(this.page - this.paginationAlpha, 2);
		},
		paginationA2(){
			return Math.min(this.page + this.paginationAlpha, this.getPagesCount() - 1);
		},
	},
	methods: {
		range: lib.range,
		
		onShowAddModal(){
			let that = this;
			this.$vfm.show({
				component: QuestionAddModal,
				bind: {
					styles: {
						display: 'block',
					},
				},
				on: {
					add(close){
						that.loadData();
						close();
					},
					cancel(close){
						close();
					},
				},
				params: {
					discipline_id: this.$route.params.discipline_id,
				},
			});
		},
		onShowEditModal(id){
			let that = this;
			this.$vfm.show({
				component: QuestionEditModal,
				bind: {
					styles: {
						display: 'block',
					},
				},
				on: {
					edit(close){
						that.loadData();
						close();
					},
					cancel(close){
						close();
					},
				},
				params: {
					discipline_id: this.$route.params.discipline_id,
					question: this.questions.find((el) => el.id == id),
				},
			});
		},
		onShowDeleteModal(id){
			let that = this;
			this.$vfm.show({
				component: QuestionDeleteModal,
				bind: {
					styles: {
						display: 'block',
					},
				},
				on: {
					delete(close){
						that.loadData();
						close();
					},
					cancel(close){
						close();
					},
				},
				params: {
					discipline_id: this.$route.params.discipline_id,
					question: this.questions.find((el) => el.id == id),
				},
			});
		},
		
		async loadSpeciality(){
			let ret = await this.appModel.doGetDiscipline(this.$route.params.discipline_id);
			if(ret.success){
				this.discipline = ret.item;
			}
		},
		
		async loadData(){
			this.loading = true;
			this.error = '';
			this.$router.push({query: Object.assign({}, this.$route.query, {
				search: this.search,
				page: this.page,
			})});
			const params = {
				search: this.search,
				start: (this.page - 1) * this.limit,
				limit: this.limit,
			};
			const ret = await this.appModel.doGetQuestions(this.$route.params.discipline_id, params);
			if(ret.success){
				this.questions = ret.list;
				this.questions_count = ret.count;
			} else {
				this.error = ret.message;
			}
			this.loading = false;
		},
		
		gotoPage(page){
			if(page >= 1 && page <= this.getPagesCount() && page != this.page){
				this.page = page;
				this.loadData();
				window.scrollTo(0, 0);
			}
		},
		// получение количества страниц
		getPagesCount(){
			return Math.ceil(this.questions_count / this.limit);
		},
	},
	async mounted(){
		this.appModel.pageTitle = 'title.questions';
		
		if(this.$route.query.search) this.search = this.$route.query.search;
		if(this.$route.query.page) this.page = parseInt(this.$route.query.page || 1);
		
		await this.loadSpeciality();
		await this.loadData();
		
		window.scrollTo(0, 0);
	},
	beforeMount(){
		if(this.authModel.isAuth()){
			if(this.authModel.isEditor()){
				this.$router.push({path: '/editor'});
			} else if(this.authModel.isStudent()){
				this.$router.push({path: '/'});
			}
		}
	},
	beforeRouteUpdate(to, from, next){
		//window.scrollTo(0, 0);
		next();
	},
};
</script>